export const documentTypes = [
  {
    id: 1,
    name: "RUC"
  },
  {
    id: 2,
    name: "Cedula"
  },
  {
    id: 3,
    name: "Pasaporte"
  },
  {
    id: 4,
    name: "Consumidor Final"
  },
  {
    id: 5,
    name: "Identificación del Exterior"
  }
];

export const businessTypes = [
  {
    id: 1,
    name: "Cliente"
  },
  {
    id: 2,
    name: "Proveedor"
  }
];

export const bankAccountTypes = [
  {
    id: 1,
    name: "Ahorro"
  },
  {
    id: 2,
    name: "Corriente"
  }
];

export const businessActivitySales = [
  {
    id: 1,
    name: "Productos"
  },
  {
    id: 2,
    name: "Servicios"
  }
];

// ── Validadores de documentos Ecuador (SRI) ──────────────────────────────────

/**
 * Valida cédula ecuatoriana (10 dígitos). Algoritmo Módulo 10.
 * El módulo 10 para cédulas es confiable — se mantiene estricto.
 */
export function validateEcuadorCedula(value) {
  if (!/^\d{10}$/.test(value)) return false;

  const digits = value.split("").map(Number);
  const province = digits[0] * 10 + digits[1];
  if (province < 1 || province > 24) return false;
  if (digits[2] >= 6) return false;

  const coefficients = [2, 1, 2, 1, 2, 1, 2, 1, 2];
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let prod = digits[i] * coefficients[i];
    sum += prod >= 10 ? prod - 9 : prod;
  }
  const verifier = (10 - (sum % 10)) % 10;
  return verifier === digits[9];
}

/**
 * Valida RUC ecuatoriano (13 dígitos) — validación de formato únicamente.
 *
 * NOTA: El SRI Ecuador mantiene RUCs históricos activos que no pasan la
 * verificación Módulo 11. Para no bloquear usuarios con RUCs reales y activos,
 * solo se valida el formato (longitud, dígitos, provincia, tipo de contribuyente
 * y que los últimos 3 dígitos sean >= 001). NO se aplica Módulo 11.
 *
 * Tipos: natural (dígito[2] 0–5), pública (dígito[2]=6), jurídica (dígito[2]=9).
 */
export function validateEcuadorRUC(value) {
  if (!/^\d{13}$/.test(value)) return false;

  const digits = value.split("").map(Number);
  const province = digits[0] * 10 + digits[1];
  // Provincias Ecuador 01–24; 30 para no residentes/exterior
  if (province < 1 || (province > 24 && province !== 30)) return false;

  const third = digits[2];

  // Persona natural: tercer dígito 0–5
  if (third >= 0 && third <= 5) {
    return parseInt(value.substring(10, 13), 10) >= 1;
  }

  // Entidad pública: tercer dígito 6
  if (third === 6) {
    return parseInt(value.substring(9, 13), 10) >= 1;
  }

  // Persona jurídica / sociedad: tercer dígito 9
  if (third === 9) {
    return parseInt(value.substring(10, 13), 10) >= 1;
  }

  return false;
}

/**
 * Valida según tipo de documento y país del negocio.
 * Solo aplica si countryCode === 'EC'.
 * Retorna string con error o null si es válido.
 *
 * @param {number} documentType - 1=RUC, 2=Cedula
 * @param {string} value
 * @param {string} countryCode
 */
export function validateDocumentByCountry(documentType, value, countryCode) {
  if (!value || !countryCode || countryCode !== "EC") return null;
  if (documentType === 1) {
    return validateEcuadorRUC(value)
      ? null
      : "El formato del RUC no es válido. Debe tener 13 dígitos y provincia correcta.";
  }
  if (documentType === 2) {
    return validateEcuadorCedula(value)
      ? null
      : "La cédula ingresada no es válida. Verifica que tenga 10 dígitos y sea correcta.";
  }
  return null;
}
